import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconArrowTop.tsx
const IconArrowTop = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "m12 10.828-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z"
	})]
});
var IconArrowTop_default = forwardRef(IconArrowTop);
//#endregion
export { IconArrowTop_default as default };
